export default "__VITE_ASSET__9bc7501f__"